// Friendly app Id should be lower case
export var AppNameToId = {
    chat: 'd870f6cd-4aa5-4d42-9626-ab690c041429',
    testapp: '07b75f22-72b5-4063-b7fc-0ed5ea8ff3ff',
    onedrive: '377c982d-9686-450e-9a7c-22aeaf1bc162',
    prepare: '1fae1e74-c74e-41ba-875e-804783f8170a',
    catchup: '94e4f8d4-aadf-4528-8f3a-48e340554cea',
    create: '83d3f491-b586-4266-8738-89776471bf21',
};
//# sourceMappingURL=constants.js.map